import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionLoaderSelector } from '../../../redux/selectors';
import { urlRegex } from '../../../utils/helper';
import { showSnackbar } from '../../../components/snackbar/actions';
import { snackbarTypes } from '../../../constants';
import { WELCOME_BAR_REQUEST } from 'pages/app/actions';
import { welcomeBarDataSelector } from '../../../redux/selectors';

export const useWelcomeBar = () => {
  const dispatch = useDispatch();
  const welcomeBarConfigLoading = useSelector(
    actionLoaderSelector(WELCOME_BAR_REQUEST)
  );
  const welcomeBarData = useSelector(welcomeBarDataSelector);
  const [welcomeBarConfig, setWelcomeBarConfig] = useState(null);

  useEffect(() => {
    if (welcomeBarData) {
      setWelcomeBarConfig(welcomeBarData);
    }
  }, [welcomeBarData]);

  useEffect(() => {
    if (welcomeBarConfig) {
      let element = document.getElementById('welcome_bar_text');
      if (typeof element != 'undefined' && element != null) {
        window.document.getElementById('welcome_bar_text').innerHTML =
          welcomeBarConfig.welcome_text.replace('rgb(17, 17, 17)', '');
      }
    }
  }, [welcomeBarConfig]);

  const handleAppBarBtnClick = (url, isNewWindow) => {
    const newWindow = isNewWindow ? '_blank' : '_self';
    if (urlRegex.test(url)) {
      window.open(url, newWindow);
    } else {
      dispatch(
        showSnackbar({ message: 'Invalid URL', type: snackbarTypes.WARNING })
      );
    }
  };

  return { welcomeBarConfigLoading, welcomeBarConfig, handleAppBarBtnClick };
};
